import * as React from "react";
import { FieldValueInteger } from "typings/index";
import { TextField } from "office-ui-fabric-react/lib/TextField";
import { BaseFieldEditor } from "./helper";
import { Label } from "office-ui-fabric-react/lib/Label";
import styled from "styled-components";


export interface Props extends BaseFieldEditor
{
    value: FieldValueInteger;
    placeholder?: string;
    
}


class TextFieldEditor extends React.Component<Props>
{
  
    onValueChange = (event: React.FormEvent<HTMLInputElement>, value: string) =>
    {
        const fieldValue: FieldValueInteger = {...this.props.value, value: parseInt(value)};
        this.props.onValueChange(fieldValue);
    }

    render()
    {
        const unit = this.props.field.unit;
        const unitLabel = unit ? <Label>{this.props.field.unit}</Label> : null;
        const fieldValue = this.props.value;
        const value = fieldValue && fieldValue.value !== undefined  ? fieldValue.value.toString() : "";
       
        return <NumbericStyle>
            <TextField 
                disabled={this.props.disabled} 
                placeholder={this.props.placeholder} 
                type="number" 
                onChange={this.onValueChange} 
                value={value} 
            />{unitLabel}
        </NumbericStyle>;
    }
}

export default TextFieldEditor;

const NumbericStyle = styled.div`

    display: flex;
    label{
        margin-left: 10px;
    }
`;


// WEBPACK FOOTER //
// ./src/components/product/FieldEditor/Integer.tsx